<script setup>
import {nextTick, onBeforeMount, ref} from "vue";
import router from "@/router/index.js";
import createTherapist from "./components/createTherapist/index.vue"
import {getRoute} from "@/hooks/getRoute.js";
import {editServiceProviderIgnoreTenant, getServiceProviderIgnoreTenant} from "@/api/serviceProvider/ignoreTenant.js";

const {route} = getRoute()

// 服务商（理疗师）ID
const providerId = ref()
onBeforeMount(async () => {
  if (!route.query.tenantId) {
    loading.value = true
    ElMessage.error("暂无理疗服务商信息")
  } else if (!route.query.providerId) {
    loading.value = true
    ElMessage.error("暂无理疗师信息")
  } else {
    ruleForm.value.tenantId = route.query.tenantId
    ruleForm.value.storeId = route.query.storeId
    providerId.value = route.query.providerId
    await getDetail()
  }
})
// 加载状态
const loading = ref(false)
/*表单信息相关*/
// 表单
const ruleForm = ref({
  tenantId: null,
  storeId: null,
  avatar: null,
  name: null,
  nameEn: null,
  phone: null,
  gender: null,
  description: null,
  descriptionEn: null,
  providerType: "THERAPIST",
  tagIdList: [],
  skillCertificates: []
})
// 处理创建理疗师
const handleUpdateTherapist = async () => {
  try {
    loading.value = true
    await editServiceProviderIgnoreTenant(ruleForm.value)
    ElMessage.success("修改成功")
    router.back()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 创建理疗师组件锚点
const createTherapistRef = ref()
// 获取理疗师信息
const getDetail = async () => {
  try {
    loading.value = true
    ruleForm.value = await getServiceProviderIgnoreTenant(providerId.value)
    createTherapistRef.value.handleReviewPic([ruleForm.value.avatar])
    createTherapistRef.value.handleReviewSkillCertificatesPic(ruleForm.value.skillCertificates)
    nextTick(() => {
      createTherapistRef.value.handleReviewTagList()
    })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <createTherapist ref="createTherapistRef" v-loading="loading" v-model="ruleForm" :is-edit="true" @success="handleUpdateTherapist"></createTherapist>
</template>

<style lang="scss" scoped>

</style>
